import React from 'react'

function index() {
  return (
    <div>
      <h1>Hi I am orders compoennt</h1>
    </div>
  )
}

export default index
